import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';

RHFDateField.propTypes = {
  name: PropTypes.string,
  disablePast: PropTypes.bool,
};

export default function RHFDateField({ name, disablePast = false, ...other }) {
  const { control, watch } = useFormContext();
  const fieldValue = watch(name);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            {...field}
            inputFormat="dd/MM/yyyy"
            // value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
            value={fieldValue === undefined || fieldValue === null || (typeof fieldValue === 'number' && fieldValue === 0) ? null : fieldValue}
            maxDate={other.maxDate || null}
            minDate={other.minDate || null}
            disablePast={disablePast}
            renderInput={(params) => <TextField
              {...params}
              error={!!error}
              fullWidth
              variant="outlined"
              helperText={error?.message}
              {...other}
            />}
          />
        </LocalizationProvider>
      )}
    />
  )
}
